
import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const emptyStateVariants = cva("flex", {
  variants: {
    alignment: {
      center: "justify-center items-center",
      start: "justify-start items-start",
    },
    spacing: {
      default: "py-8 md:py-12 lg:py-16 px-4 md:px-6 lg:px-10",
      compact: "py-4 md:py-6 lg:py-8 px-4 md:px-6 lg:px-10",
    },
    context: {
      unauthenticated: "justify-center items-center py-8 md:py-12 lg:py-16 px-4 md:px-6 lg:px-10",
      authenticated: "justify-start items-start py-1 md:py-2 lg:py-3 px-4 md:px-6 lg:px-10",
    }
  },
  defaultVariants: {
    alignment: "center",
    spacing: "default",
  },
});

export interface EmptyStateProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof emptyStateVariants> {
  children: React.ReactNode;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, alignment, spacing, context, children, ...props }, ref) => {
    // If context is provided, it will override alignment and spacing
    return (
      <div
        ref={ref}
        className={cn(
          emptyStateVariants({
            alignment: context ? undefined : alignment,
            spacing: context ? undefined : spacing,
            context,
          }),
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

EmptyState.displayName = "EmptyState";

export { EmptyState, emptyStateVariants };
